//region :: Imports ::
import {Configuration, LogLevel} from '@azure/msal-browser';

//endregion

/** */
class MAuthConfiguration {

    /** */
    public static create(clientId: string, tenantId: string, logLevel: LogLevel): Configuration {

        return {
            auth: {
                clientId: clientId,
                authority: `https://login.microsoftonline.com/${tenantId}`,
                redirectUri: '/',
                postLogoutRedirectUri: '/logout'
            },
            system: {
                loggerOptions: {
                    logLevel: logLevel,
                    loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {

                        if(containsPii) {
                            return;
                        }

                        switch(level) {
                            case LogLevel.Error:
                                console.error(message);
                                return;
                            case LogLevel.Info:
                                console.info(message);
                                return;
                            case LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case LogLevel.Warning:
                                console.warn(message);
                                return;
                            default:
                                return;
                        }

                    }
                }
            }
        };
    }

}

export default MAuthConfiguration;
